import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Loading from '../components/Loading';

type Props = {
  children: {}
  readyStates: boolean[]
}

// Shows a loading indicator until every entry in `readyStates` is truthy, then
// renders the children. Once it has been ready once, it stays rendered even if
// `readyStates` later flip back to false (the `alreadyLoaded` latch), so the view
// doesn't flicker back to the spinner.
//
// NOTE: render off `isReady || alreadyLoaded` directly. The previous version
// flipped the latch with a setState call inside useMemo — an unsupported side
// effect that React 19 ignores, leaving the view stuck on <Loading /> forever
// even after readyStates became true.
const LoadWhenReady = (props: Props) => {
  const { children, readyStates } = props;
  const [alreadyLoaded, setAlreadyLoaded] = useState(false);

  const isReady = readyStates.every(state => state);

  useEffect(() => {
    if (isReady && !alreadyLoaded) {
      setAlreadyLoaded(true);
    }
  }, [isReady, alreadyLoaded]);

  if (isReady || alreadyLoaded) {
    return children;
  }

  return <Loading />;
};

LoadWhenReady.propTypes = {
  children: PropTypes.node.isRequired,
  readyStates: PropTypes.array.isRequired,
};

export default LoadWhenReady;
